import React, {useEffect} from "react";
import {appdata} from "../../logic_tmp/appdata/AppData";
import {useHistory} from "react-router-dom";
import {getProductParamsTest} from "../../logic/setup/ProdcutParamsParser";
import {assertEqual} from "../../unittests/UnitTestHelper";
import {parseUrl} from "../../logic/setup/ParametersParser";
import {parseDateStr} from "../../logic/setup/PriceCalculator";
import {logPageOpened} from "../model/utils";
import {FlexPrice} from "../price/FlexPrice";
import {GenericMessage} from "../thankyou/GenericMessage";
import {Price} from "../price/Price";
import {Sectors} from "../price/Sectors";
import {LeadNew} from "../lead/LeadNew";

export function testBeginRouterLogic()
{
    let data = parseUrl({}, getProductParamsTest())
    assertEqual("/flexPrice",calculateNextPage(data))
}
export function calculateNextPage(data)
{

    if (data.product.date !== "ANY")
    {
        let eventDate = parseDateStr(data.product.date)

        //if (new Date().getTime() > eventDate.getTime()){
        //    appdata.messageKey = "ThisEventHasPassed"
        //    return "/genericMessage"
        //}
    }
    if (data.product["sectors"] !== undefined)
        return "/sectorsSelector"
    else if (data.product.type === "LEADGEN")
        return "/lead"
    if (data.product.priceModel === "FLEX")
        return "/flexPrice"
    else if (data.product.priceModel === "FIXED")
        return "/price"
    else if (data.product.priceModel === "FREE")
        return "/price"
    else
        throw Error("Unsupported price model")

    /*
    if ("777" === data.key2 || "778" === data.key2)
        return  "/lead"
    else
    if (data.product.priceModel === "FLEXcon")
        if (data.productCode === "GN-DONATE")
            return "/flexPriceGn"
        else
            return "/flexPrice"
    else
    if (data.product.priceModel === "SIMPLE")
        return "/amt"
    else
    if (data.product.priceModel === "FIXED")
        return "/price"
*/

}

export function Begin() {
    appdata.viewType = "Pay"
    const nextPage = calculateNextPage(appdata)
    useEffect(() => {
        logPageOpened(nextPage,appdata.viewType)
    }, [])
    return (
        <div>
            {("/price" === nextPage)?<Price/>:<div/>}
            {("/lead" === nextPage)?<LeadNew/>:<div/>}
            {("/sectorsSelector" === nextPage)?<Sectors/>:<div/>}
            {("/flexPrice" === nextPage)?<FlexPrice/>:<div/>}
            {("/genericMessage" === nextPage)?<GenericMessage/>:<div/>}
        </div>
    )
}
